const LINKS = [
  ["#book", "Book"],
  ["#watch", "Watch"],
  ["#contents", "Contents"],
  ["#author", "Author"],
  ["#contact", "Contact"],
];

export const Logo = () => (
  <svg width="30" height="30" viewBox="0 0 32 32" aria-hidden="true">
    <rect x="3" y="3" width="12" height="12" fill="#f2c14e" />
    <rect x="17" y="3" width="12" height="12" fill="none" stroke="#f2c14e" strokeWidth="2" />
    <rect x="3" y="17" width="12" height="12" fill="none" stroke="#f2c14e" strokeWidth="2" />
    <rect x="17" y="17" width="12" height="12" fill="#e07a9b" />
  </svg>
);

export const Nav = () => (
  <nav className="sticky top-0 z-40 bg-ink text-marigold" data-testid="site-nav">
    <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between gap-4">
      <a href="#top" className="flex items-center gap-3" data-testid="nav-logo-link">
        <Logo />
        <span className="font-mono text-sm font-bold">families_reimagined</span>
      </a>
      <div className="hidden md:flex gap-8 fr-lbl font-mono">
        {LINKS.map(([href, label]) => (
          <a key={href} href={href} className="relative hover:text-rose transition-colors duration-200" data-testid={`nav-link-${label.toLowerCase()}`}>
            {label}
          </a>
        ))}
      </div>
      <a href="#join" className="fr-lbl font-mono bg-marigold text-ink px-4 py-2 transition-colors duration-200 hover:bg-rose" data-testid="nav-join-button">
        Join
      </a>
    </div>
  </nav>
);
